"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/web.dom.iterable");
var _customerCoupon = require("@/api/activity/customerCoupon");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'customerCouponeSend',
  emits: ['customerCouponeRecordUsed'],
  props: {
    storeName: {
      type: String,
      default: ''
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler() {
        this.getRecordList();
        this.getShopList();
      }
    }
  },
  mounted: function mounted() {
    this.getRecordList();
    this.getShopList();
  },
  data: function data() {
    return {
      // couponSendLogVisible: false,
      shoplist: [],
      // 搜索表单
      searchForm: {
        storeId: '',
        storeName: '',
        issueMode: '',
        issueStatus: '',
        issueType: '',
        issuedAtStart: '',
        issuedAtEnd: '',
        isRetOrd: '',
        relatedOrderNo: '',
        page: 1,
        limit: 10,
        total: 0
      },
      // 日期范围
      dateRange: [],
      couponInfoLogFrom: {
        storeId: null,
        recordId: null,
        page: 1,
        limit: 10,
        total: 0
      },
      // 数据列表
      recordList: [],
      couponSendLogList: [],
      loading: false,
      loadingLog: false,
      downloadLoading: false,
      resPath: ''
    };
  },
  methods: {
    getShopList: function getShopList() {
      var _this = this;
      _couponCode.default.getStoreList().then(function (res) {
        _this.shoplist = res;
      });
    },
    // 获取数据列表
    getRecordList: function getRecordList() {
      var _this2 = this;
      this.loading = true;
      (0, _customerCoupon.getPaperCouponStoreSend)(this.searchForm).then(function (res) {
        if (res.code == 200) {
          _this2.recordList = res.records || [];
          _this2.searchForm.total = res.total || 0;
        } else {
          _this2.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getRecordList();
    },
    // 导出
    handleExport: function handleExport() {
      var _this3 = this;
      this.downloadLoading = true;
      (0, _customerCoupon.getPaperCouponStoreSendExport)(this.searchForm).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '纸质券发放记录.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this3.downloadLoading = false;
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getRecordList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getRecordList();
    },
    // 发券详情
    // couponInfo(row) {
    //   this.getCouponSendInfo(row);
    //   this.couponSendLogVisible = true;
    // },
    getCouponSendInfo: function getCouponSendInfo(row) {
      var _this4 = this;
      this.loadingLog = true;
      if (row != null) {
        this.couponInfoLogFrom.storeId = row.storeId;
        this.couponInfoLogFrom.recordId = row.id;
      }
      (0, _customerCoupon.getCouponSendInfo)(this.couponInfoLogFrom).then(function (res) {
        if (res.code == 200) {
          res.records.forEach(function (item) {
            item.couponNum = item.couponNum * row.issueNum; // 确保 couponNum 字段存在且有默认值
          });
          _this4.couponSendLogList = res.records || [];
          _this4.couponInfoLogFrom.total = res.total || 0;
        } else {
          _this4.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this4.loadingLog = false;
      });
    },
    handleLogSizeChange: function handleLogSizeChange(val) {
      this.couponInfoLogFrom.limit = val;
      this.getCouponSendInfo();
    },
    handleLogCurrentChange: function handleLogCurrentChange(val) {
      this.couponInfoLogFrom.page = val;
      this.getCouponSendInfo();
    },
    // 处理日期范围变化
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.searchForm.issuedAtStart = val[0];
        this.searchForm.issuedAtEnd = val[1];
      } else {
        this.searchForm.issuedAtStart = '';
        this.searchForm.issuedAtEnd = '';
      }
    },
    // 获取状态类型
    getIssueStatusType: function getIssueStatusType(status) {
      switch (status) {
        case 0:
          return 'warning';
        case 1:
          return 'info';
        case 2:
          return 'success';
        default:
          return '';
      }
    },
    // 获取状态文本
    getIssueStatusText: function getIssueStatusText(status) {
      switch (status) {
        case 0:
          return '待领取';
        case 1:
          return '部分领取';
        case 2:
          return '已领完';
        case 3:
          return '已失效';
        default:
          return '';
      }
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};